import { TbGalaxy } from "react-icons/tb";
import { useState } from "react";

const PCView = ({ previewUrl, reloadPrev }) => {
  const [loading, setLoadingPreview] = useState(true);

  const handleIframeLoad = () => {
    setLoadingPreview(false);
  };

  return (
    <div className="view_body_item">
      {loading && (
        <div className="loading-bar-container">
          <div className="loading-bar" />
        </div>
      )}
      <div className="pc_preview">
        <iframe
          className="fade-in"
          src={previewUrl}
          style={{ width: "100%", height: "100%", border: "none" }}
          title="Project Preview"
          onLoad={handleIframeLoad}
        />
      </div>


    </div>
  );
};

export default PCView;
